// src/shared/components/FaviconLinks.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { publicPath } from '../../config/env';

/**
 * Injects favicon <link> tags into the document head.
 * Expects your files to live under /public/images/favicon/…
 */
export default function FaviconLinks() {
  return (
    <Helmet>
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={publicPath('/images/favicon/apple-touch-icon.png')}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={publicPath('/images/favicon/favicon-32x32.png')}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={publicPath('/images/favicon/favicon-16x16.png')}
      />
      <link
        rel="manifest"
        href={publicPath('/images/favicon/site.webmanifest')}
      />
    </Helmet>
  );
}
